import { Pipe, PipeTransform } from '@angular/core';
import { Role } from 'src/app/module/security/role/role.model';
/**
 * Retourne le nom du client
 * * name, roleShortDescriptionFr, roleShortDescriptionEn
 */
@Pipe({
  name: 'getRoleName',
})
export class RoleNamePipe implements PipeTransform {
  transform(roleId: string, roleList: Role[], fieldToReturn: string): string {
    if (roleList) {
      let name = roleList
        .filter((c: any) => c.id == roleId)
        .map((c: any) => {
          if (fieldToReturn === 'roleShortDescriptionFr') return c.roleShortDescriptionFr ?? '';
          if (fieldToReturn === 'roleShortDescriptionEn') return c.roleShortDescriptionEn ?? '';
          else return c.name;
        });
      if (name && name.length > 0) {
        return name[0];
      }
    }
    return '';
  }
}
